import { useState } from "react";
import { Lock } from "lucide-react";
import { adminApi, formatApiErrorDetail } from "@/lib/adminApi";

const FIELD =
  "w-full rounded border border-slate-600 bg-steel px-4 py-2.5 text-sm text-white placeholder:text-slate-500 focus:border-royal focus:outline-none transition-colors";

export function AdminLogin({ onSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await adminApi.post("/auth/login", { email, password });
      onSuccess(data);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="min-h-[70vh] flex items-center justify-center py-20 px-6" data-testid="admin-login-section">
      <form
        data-testid="admin-login-form"
        onSubmit={handleSubmit}
        className="w-full max-w-sm space-y-5 rounded-2xl border border-slate-700 bg-steel-light p-8 shadow-2xl blueprint-grid"
      >
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-royal/40 bg-royal/15 text-royal-bright">
            <Lock className="h-5 w-5" aria-hidden="true" />
          </span>
          <div>
            <p className="font-poster text-lg font-bold text-white leading-tight">Admin sign in</p>
            <p className="font-mono-sub text-[11px] uppercase tracking-wider text-slate-400">Private area</p>
          </div>
        </div>
        <div>
          <label htmlFor="admin-email" className="block text-xs font-mono-sub text-slate-300 mb-1">EMAIL</label>
          <input id="admin-email" data-testid="admin-email-input" type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={FIELD} />
        </div>
        <div>
          <label htmlFor="admin-password" className="block text-xs font-mono-sub text-slate-300 mb-1">PASSWORD</label>
          <input id="admin-password" data-testid="admin-password-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={FIELD} />
        </div>
        {error && (
          <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>
        )}
        <button
          type="submit"
          data-testid="admin-login-submit"
          disabled={busy}
          className="w-full rounded bg-royal py-3 text-sm font-bold text-white transition-colors hover:bg-royal-dark disabled:opacity-60"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </section>
  );
}
